import PropTypes from 'prop-types'

import ConfirmationModal from 'components/common/ConfirmationModal'

export default function RerunConfirmationModal({
  open,
  onConfirm,
  onCancel,
  isDraftState
}) {
  const title = isDraftState ? 'Run this Scenario?' : 'Re-run this Scenario?'
  const message = isDraftState
    ? 'Are you sure you want to run this scenario?'
    : 'Are you sure you want to re-run this scenario?'

  return (
    <ConfirmationModal
      confirmButtonType="creative"
      confirmText="Run Scenario"
      message={message}
      open={open}
      title={title}
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  )
}

RerunConfirmationModal.propTypes = {
  open: PropTypes.bool,
  isDraftState: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func
}
